import { format, formatDistanceToNow, parseISO, fromUnixTime } from "date-fns-jalali";
import { isFuture } from "date-fns-jalali/isFuture";
import { memo } from "react";

interface DateTimeViewerProps {
  mode?: "date" | "datetime" | "distance" | "time" | string;
  value?: string | Date | number;
}

export const DateTimeViewer = memo(({ value, mode = "datetime" }: DateTimeViewerProps) => {
  return <span className="break-normal">{FormatDateTime(value, mode)}</span>;
});

export const FormatDateTime = (value?: string | Date | number, mode: "date" | "datetime" | "distance" | "time" | string = "datetime") => {
  if (!value) {
    return "-";
  }

  let date: Date;

  try {
    date = value instanceof Date ? value : typeof value == "number" ? fromUnixTime(value) : parseISO(value);
  } catch {
    return "-";
  }

  if (mode === "distance") {
    return `${formatDistanceToNow(date)} ${isFuture(date) ? "مانده" : "پیش"}`;
  }

  if (mode === "date") {
    return format(date, "yyyy/MM/dd");
  }

  if (mode === "time") {
    return format(date, "HH:mm:ss");
  }

  if (mode === "datetime") {
    return format(date, "yyyy/MM/dd (HH:mm:ss)");
  }

  return format(date, mode);
};
